export const COOKIES_ENABLED = 'cookiesEnabled'
export const SCREEN_LOADING = 'screenLoading'

export const CASE_NUMBER = 'caseNumber'
export const CONFIRM_CASE_NUMBER = 'confirmCaseNumber'
export const AMOUNT_OWING = 'amountOwing'
export const PAYMENT_AMOUNT = 'paymentAmount'
export const PAYMENT_AMOUNT_FULL = 'paymentAmountFull'
export const MIN_PAYMENT_AMOUNT = 'minPaymentAmount'
export const CASE_SOT_ID = 'caseSotId'
export const RECEIPT_DETAIL = 'receiptDetail'
export const CASE_TYPE = 'caseType'
export const EMAIL_ADDRESS = 'emailAddress'
export const CONFIRM_EMAIL_ADDRESS = 'confirmEmailAddress'
export const EDIT_CASE_NUMBER = 'editCaseNumber'
export const ADD_CASE = 'addCase'
export const EDIT_CASE = 'editCase'
export const DELETE_CASE = 'deleteCase'

export const CLEAR_ALL = 'clearAll'
export const CLEAR_CASE_INFO = 'clearCaseInfo'
